import Hero from "../../components/Hero";
import { happyOranges } from "../../themes/colours";
import { Col, Container, Row, Image } from "react-bootstrap";
import "./styles.scss";
import { Helmet } from "react-helmet";
const CreativePage = () => {
  return (
    <>
      <Helmet>
        <title>
          John Lewis creative solutions for retail marketing campaigns
        </title>
        <meta
          name="description"
          content="John Lewis Partnership has a fully serviced creative studio that can help you craft engaging, high-impact retail media assets for your marketing campaigns."
        />
      </Helmet>
      <Hero
        colour={happyOranges.orange}
        title="Harness the power of John Lewis creative"
        customClass="small-hero"
      />
      <Container className="w-100 main-container ">
        <p className="body-l body-text mb-4">
          Our fully serviced creative studio can help you craft engaging, high
          impact assets for your campaign. Capturing customer attention, getting
          deeper engagement and driving better campaign performance.
        </p>
        <p className="body-l body-text mb-4">
          At the moment we’re able to offer our creative capabilities for John
          Lewis only.
        </p>

        <p className="body-l body-text">
          Get in touch if you’d like more information on working with us.
        </p>
      </Container>
      <Container className="w-100 main-container pt-0">
        <Row className="creative-block">
          <Col xs={12} lg={4}>
            <Image src="/assets/photography/JL SUMMER WRAPPER KIDS SHOT 10 001 ITGproofedRGB.jpg" />
          </Col>
          <Col className="mt-2 mb-2 mt-lg-0 mb-lg-0" xs={12} lg={4}>
            <Image src="/assets/photography/Copy of 2026 SUM WRAPPER DAY 01 SHOT 16 0511 SHOWER OPT ITGproofedCMYK.jpg" />
          </Col>
          <Col xs={12} lg={4}>
            <Image src="/assets/photography/2026 SUM WRAPPER SHOT 17 120 (1).jpg" />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreativePage;
